import { Component, DestroyRef, inject, input, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MatIconButton } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { OrderControllerService } from "src/app/services";

@Component({
    selector: 'app-order-refresh-timer',
    templateUrl: './order-refresh-timer.component.html',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatIconButton
    ],
    standalone: true
})
export class OrderRefreshTimerComponent implements OnInit {
  public dataRefreshForm: UntypedFormGroup; // how often to refresh data

  public readonly isLoadingData = input.required<boolean>();

  private orderControllerService: OrderControllerService = inject(OrderControllerService);
  private formBuilder = inject(UntypedFormBuilder);
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.dataRefreshForm = this.formBuilder.group({
      refreshDataTimeSelectBox: '300' // time in seconds
    });

    // person wants to refresh data at a different time interval UI
    this.dataRefreshForm.valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formFilter: any) => {
        this.orderControllerService.updateRefreshTimer(formFilter.refreshDataTimeSelectBox * 1000, true);
    });

    // initialize refresh time in controller
    this.orderControllerService.updateRefreshTimer(this.dataRefreshForm.value.refreshDataTimeSelectBox * 1000, true);
  }

  public refreshData(): void {
    this.orderControllerService.triggerTimerRefreshedEvent();
  }

}